<template>
  <div :style="{ marginLeft: (depth * 18) + 'px' }" class="border-left pl-3 mb-2">
    <div>
      <strong>{{ node.lot_number }}</strong> · {{ node.product }}
      <span v-if="node.supplier_lot_number" class="text-muted">· supplier lot {{ node.supplier_lot_number }}</span>
      <span v-if="node.supplier" class="text-muted">· {{ node.supplier }}</span>
    </div>
    <div class="small text-muted" v-if="node.purchase">Purchase {{ node.purchase.purchase_order }} on {{ node.purchase.date }}</div>
    <div class="small text-muted" v-if="node.production_order">Produced by {{ node.production_order.order_number }} on {{ node.production_order.completed_at }}</div>
    <div v-for="(input, i) in (node.inputs || [])" :key="i" class="mt-1">
      <div class="small">{{ qty(input.quantity) }} of {{ input.product }}<span v-if="!input.lot" class="text-danger"> (no lot recorded)</span></div>
      <trace-node v-if="input.lot" :node="input.lot" :depth="depth + 1"></trace-node>
    </div>
  </div>
</template>

<script>
import { fmtQty } from './mfgHelpers';

export default {
  name: 'TraceNode',
  props: { node: { type: Object, required: true }, depth: { type: Number, default: 0 } },
  methods: { qty: fmtQty },
};
</script>
